let adhibition = {
    title: "应用中心",
    accountNumber: "选择登录账号",
    subusername: "账号",
    multifactorAuthentication: "多因素认证",
    subusernameMsg: "请选择子账号",
    authentication: "认证",
    noData:"暂无数据",
    authentications: "登录",
    apply:"申请应用",
    applyApp:"申请应用",
    selectAppType:"选择应用",
    pendApproval:"待审批",
    refused:"已拒绝",
    applyReasonRequire:"需要经过管理员审批后才能拥有该应用的访问权限，请填写申请原因。",
    noRequireReason:"该应用设置了无需审批，可直接申请成功。",
    applyReason:"申请原因",
    placePutReason:"请填写申请原因，最多不超过200字",
    pleaseSelectType:"请选择应用！",
    pleaseApplyReason:"请输入申请原因！",
    applyReasonMaxLength:"申请原因最多不超过200字！",
    downZip:"下载客户端插件",
    removeApp:'移除应用',
    downSAP:{
        des:"在收到浏览器提示时，点击“打开XXX”唤起客户端",
        noTip:"若未收到提示，请先安装",
        plugIn:"客户端插件",
    },
    appGroup:{
        addGroup:"添加分组",
        editGroup:"修改分组",
        sureDeleteGroup:"确定删除此项分组吗？",
        selectBrowser:"请选择打开应用的浏览器",
        noData:"暂无数据",
        edit:"修改",
        delete:"删除",
        groupName:"分组名称",
        requireGroupName:"分组名称不能为空",
        maxGroupName:"分组名称不能超过20个字符",
        whole:"全部",
    },
    browserList:{
      'firefox':"火狐浏览器",
      'qq':"QQ浏览器",
      'sogou':"搜狗浏览器",
      'safety360':"360浏览器",
      'safety360Speed':"360极速浏览器",
    }
}

export default adhibition
